import {
  QUARTER_ROTATION_RADIANS,
  THREE_QUARTER_ROTATION_RADIANS,
} from '@/helpers/angleConstants';
import type { StationCarrierSide } from './stationCapacity';

/**
 * Gets the logical (visual) POI angle for a carrier side.
 * This represents how the POI is physically oriented in the UI:
 * - 'long' side: 90° (π/2)
 * - 'short' side: 0°
 */
export const getLogicalPoiAngle = (side: StationCarrierSide): number =>
  side === 'long' ? QUARTER_ROTATION_RADIANS : 0;

/**
 * Gets the stored POI angle value in preferences.
 * This is used for undo/redo and persistence:
 * - 'long' side: 270° (3π/2)
 * - 'short' side: 0°
 */
export const getStoredPoiAngle = (side: StationCarrierSide): number =>
  side === 'long' ? THREE_QUARTER_ROTATION_RADIANS : 0;
